module.exports = __webpack_public_path__ + "img/facebook.3b7b7b52.svg";